module.exports = __webpack_public_path__ + "img/maxii.662d4415.png";